import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Shimmer from '../../common/Shimmer';
import { PaymentHistoryPolicyCard } from './PaymentHistoryPolicyCard';

import { loadPolicyDetails } from '../../../actions';
import { formatShortDateByLanguage } from '../../../services/language.utils';
import { MY_ACCOUNT } from '../../../constants';

import './css/PaymentHistoryScreen.css';

const PaymentHistoryPolicies = ({
  breadCrumbs,
  loading = true,
  policies = [],
}) => {
  const { t } = useTranslation('myAccount');
  const dispatch = useDispatch();

  const onClickCard = useCallback((policyNumber) => () => {
    if (breadCrumbs) {
      breadCrumbs.onAddBreadcrumbItem({
        id: MY_ACCOUNT.paymentHistoryList,
        name: t('breadCrumbs.breadCrumbPolicy', {
          policyNumber,
        }),
      });
    }

    dispatch(loadPolicyDetails(policyNumber));
  }, [breadCrumbs]);

  return (
    <div className="Payment-history-screen-policies-container">
      <h2>{t('paymentHistorySection.insurancePolicies')}</h2>

      <div className="Payment-history-screen-policies-card-container">
        <Shimmer
          element="fragment"
          height={56}
          visible={loading || policies.length === 0}
          width={940}
        >
          {policies.map(({
            CoverageStartDate,
            ExpirationDate,
            Number,
            Status,
          }) => (
            <PaymentHistoryPolicyCard
              key={String(Number)}
              expirationDate={formatShortDateByLanguage(ExpirationDate)}
              onClick={onClickCard(Number)}
              policyNumber={Number}
              startDate={formatShortDateByLanguage(CoverageStartDate)}
              status={Status}
            />
          ))}
        </Shimmer>
      </div>
    </div>
  );
};

export { PaymentHistoryPolicies };
